import React from "react";
import { useIntl } from "react-intl";
import { PeekBox, useTheme } from "@piiqtechnologies/ui-components";
import { RankingEndLabel } from "./RankingEndLabel";
import messages from "./messages.i18n";
export const RankingChart = ({ min, max, minTooltip, maxTooltip, balloon, markers }) => {
    const intl = useIntl();
    const theme = useTheme();
    return (React.createElement(PeekBox, { sx: { position: "relative", py: 1, px: 2 } },
        React.createElement(PeekBox, { sx: { display: "flex", alignItems: "center", pt: "44px" } },
            React.createElement(RankingEndLabel, { value: String(Math.round(min)), caption: intl.formatMessage(messages.minLabel), tooltipTitle: minTooltip }),
            React.createElement(PeekBox, { sx: { position: "relative", flexGrow: 1 } },
                balloon,
                React.createElement(PeekBox, { sx: { position: "relative", height: 35 } },
                    React.createElement(PeekBox, { sx: {
                            position: "absolute",
                            top: "calc(50% - 1px)",
                            left: 0,
                            right: 0,
                            height: 2,
                            bgcolor: theme.palette.grey[300],
                            zIndex: 0,
                        } }),
                    markers,
                    React.createElement(PeekBox, { sx: {
                            position: "absolute",
                            left: 0,
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: 2,
                            height: 12,
                            bgcolor: theme.palette.grey[400],
                            zIndex: 3,
                        } }),
                    React.createElement(PeekBox, { sx: {
                            position: "absolute",
                            right: 0,
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: 2,
                            height: 12,
                            bgcolor: theme.palette.grey[400],
                            zIndex: 3,
                        } }))),
            React.createElement(RankingEndLabel, { value: String(Math.round(max)), caption: intl.formatMessage(messages.maxLabel), tooltipTitle: maxTooltip }))));
};
export default RankingChart;
